
// src/components/NewsCoverflowImages.jsx
import React from "react";
import Slider from "react-slick";
import { Modal } from "react-bootstrap";
import "./news-coverflow-images.css";

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <button
      className={`coverflow-arrow prev ${className}`}
      style={style}
      onClick={onClick}
      aria-label="Anterior"
      type="button"
    >
      ‹
    </button>
  );
}

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <button
      className={`coverflow-arrow next ${className}`}
      style={style}
      onClick={onClick}
      aria-label="Siguiente"
      type="button"
    >
      ›
    </button>
  );
}

/**
 * Carrusel coverflow (solo imagen) + lightbox
 * items: [{ id: string, src: string, alt?: string }]
 * align: "left" | "center"
 */
export default function NewsCoverflowImages({ items = [], align = "left" }) {
  const [show, setShow] = React.useState(false);
  const [activeSrc, setActiveSrc] = React.useState("");
  const [activeAlt, setActiveAlt] = React.useState("Imagen");

  if (!items.length) return null;

  const settings = {
    dots: false,
    arrows: true,
    infinite: items.length > 3,
    speed: 420,
    centerMode: true,
    slidesToShow: 1,
    centerPadding: "14%", // puedes bajar a 10–12% para hacerlo aún más compacto
    slidesToScroll: 1,
    swipeToSlide: true,
    autoplay: false,
    pauseOnHover: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      { breakpoint: 1200, settings: { centerPadding: "12%" } },
      { breakpoint: 992,  settings: { centerPadding: "10%" } },
      { breakpoint: 768,  settings: { centerPadding: "6%", slidesToShow: 1 } },
      { breakpoint: 576,  settings: { centerPadding: "4%", slidesToShow: 1 } },
    ],
  };

  const handleOpen = (src, alt) => {
    setActiveSrc(src);
    setActiveAlt(alt || "Imagen");
    setShow(true);
  };

  const handleClose = () => setShow(false);

  return (
    <div className={`coverflow-images-wrapper ${align === "left" ? "align-left" : "align-center"}`}>
      <Slider {...settings}>
        {items.map((it) => (
          <div key={it.id} className="coverflow-slide">
            <div className="coverflow-card">
              <div
                className="coverflow-media"
                role="button"
                tabIndex={0}
                onClick={() => it.src && handleOpen(it.src, it.alt)}
                onKeyDown={(e) => {
                  if ((e.key === "Enter" || e.key === " ") && it.src) {
                    e.preventDefault();
                    handleOpen(it.src, it.alt);
                  }
                }}
                aria-label="Abrir imagen en grande"
              >
                {it.src ? (
                  <img
                    src={it.src}
                    alt={it.alt || "Imagen"}
                    className="coverflow-img"
                    loading="lazy"
                  />
                ) : (
                  <div className="coverflow-placeholder">Sin imagen</div>
                )}
              </div>
            </div>
          </div>
        ))}
      </Slider>

      {/* Lightbox (Modal) */}
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="lg"
        aria-labelledby="lightbox-title"
        className="lightbox-modal"
      >
        <Modal.Body className="p-0">
          <button
            type="button"
            className="lightbox-close"
            onClick={handleClose}
            aria-label="Cerrar"
          >
            ✕
          </button>
          <div className="lightbox-media">
            {activeSrc && (
              <img
                src={activeSrc}
                alt={activeAlt}
                className="lightbox-img"
              />
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
